export const headersAutorization = (value) => {
  const token = value || localStorage.getItem('token');
  return {
    Authorization: `Bearer ${token}`,
  };
};
